import { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import styles from "./button-with-icon.less";

type ButtonWithIconProps = {
    id?: string;
    disabled?: boolean;
    title: string;
    text?: string;
    variant?: string;
    icon?: IconDefinition;
    className?: string;
    onClick: () => void;
};

export const ButtonWithIcon = forwardRef<HTMLButtonElement, ButtonWithIconProps>((props, ref) => {
    const { id, disabled, title, text, variant, icon, className, onClick } = props;

    return (
        <Button
            id={id}
            ref={ref}
            variant={variant}
            disabled={disabled}
            className={classNames(styles.buttonWithIcon, className)}
            title={title}
            onClick={onClick}
        >
            {icon && <FontAwesomeIcon className={styles.icon} icon={icon} />}
            {text && <span>{text}</span>}
        </Button>
    );
});